export default "__VITE_ASSET__PEsIxkJt__"